__turbopack_context__.v({
  "bannedWarning": "hdNqUq_bannedWarning",
  "legalityTable": "hdNqUq_legalityTable",
  "previewedWarning": "hdNqUq_previewedWarning",
  "title": "hdNqUq_title",
});
